var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-contents"},[_vm._t("default",null,{"label":_vm.label,"color":_vm.color,"status":_vm.userRecord.status,"reason":_vm.userRecord.reason,"group":_vm.userRecord.group})],2)}
var staticRenderFns = []

export { render, staticRenderFns }